export enum ECareersActions {
    APPLY_POSITION = 'APPLY_POSITION',
    GET_CAREERS = 'GET_CAREERS',
}
